import { Flex, Grid, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useInterval } from 'usehooks-ts'
import { useResizeObserverDebounced } from '../../../../../shared/hooks/useElementSize'
import styles from '../index.module.css'

const parseTimerTime = (totalTime) => {
    if (totalTime === "expired") return 0
    const timeArray = totalTime.split(":")
    return ((parseInt(timeArray[0]) * 60) + parseInt(timeArray[1]))
}

export const Application_TrackPlannedStatus = (props) => {
    const { cardRef } = props;
    const { width = 0, height = 0 } = useResizeObserverDebounced(cardRef);
    const task = useSelector(state => state.applications.currentApplicationData);
    const screens = Grid.useBreakpoint();
    const isPlanned = true || task?.status === 'Запланировано';

    // Initialize timerDuration from currentApplication?.timer
    const initialTimer = task?.timer ? parseTimerTime(task?.timer) : null;
    const [timerDuration, setTimerDuration] = useState(initialTimer);
    const [timerString, setTimerString] = useState('');

    // Reset timer when currentApplication?.timer changes
    useEffect(() => {
        setTimerDuration(initialTimer);
    }, [initialTimer]);

    useInterval(() => {
        if (timerDuration !== null && timerDuration > 0) {
            setTimerDuration(timerDuration - 1);
        }
    }, timerDuration !== null && timerDuration > 0 ? 1000 : null);

    useEffect(() => {
        if (timerDuration !== null && timerDuration > 0) {
            const minutes = Math.floor(timerDuration / 60);
            const seconds = timerDuration % 60;
            setTimerString(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        } else if (timerDuration === 0) {
            setTimerString('00:00');
        } else {
            setTimerString('');
        }
    }, [timerDuration]);

    const sizes = {
        lg: screens.lg && width >= 900,
        md: (width >= 800),
    }

    if (isPlanned) {
        const transition = 'all 0.3s ease-in-out';
        return (
            <>
                <Flex
                    className={styles.task_planed_status_container}
                    justify="space-between"
                    gap={16}
                >
                    <Flex
                        vertical
                        style={{ width: '100%', padding: sizes.lg ? '12px 48px' : sizes.md ? 12 : 0, transition }}
                        gap='small'
                        justify='center'
                    >
                        <Typography.Text style={{ color: '#FFFFFF', margin: 0, fontSize: 20, fontWeight: 'bold' }}>Ура, мы получили вашу заявку!</Typography.Text>
                        <Typography.Text style={{ color: '#FFFFFF', margin: 0, fontSize: 18 }}>Сейчас Asista ищет подходящего айтишника из нашей команды, это займет максимум 15 минут.</Typography.Text>
                    </Flex>
                    <Flex vertical style={{ minWidth: sizes.md ? 400 : 200 }} justify='center' align='center' gap='small'>
                        <Typography.Text style={{ color: '#FFFFFF', margin: 0, fontSize: sizes.md ? '9.5em' : '6em', lineHeight: sizes.md ? '120px' : '64px', userSelect: 'none', pointerEvents: 'none', transition }}>
                            {timerString}
                        </Typography.Text>
                    </Flex>
                </Flex>
            </>
        )
    }

    return (null)
}